import Meditation2 from './Meditation2'

export default Meditation2
// eslint-disable-next-line import/export
export * from './Meditation2'
